import { Link } from 'react-router-dom';
import { FaPhone } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { getExperienceYears } from '../../../pages/home';

const footers = () => {

  const experienceYears = getExperienceYears();
  const thisYear = new Date().getFullYear();

  const data = {
    explore: {
      caption: "Explore",
      body: [
        {
          title: "Beranda",
          link: "https://niecindonesia.com/",
        },
        {
          title: "Kuliah di Australia",
          link: "https://niecindonesia.com/country/aus",
        },
        {
          title: "Kuliah di Swiss",
          link: "https://niecindonesia.com/country/che",
        },
        {
          title: "Kursus Bahasa",
          link: "https://kursusbahasa.niecindonesia.com/",
        },
        {
          title: "World Education Festival",
          link: "https://edufest.niecindonesia.com/",
        },
        {
          title: "Info Session",
          link: "https://infosession.niecindonesia.com/",
        },
        {
          title: "Karir",
          link: "http://localhost:3000/career",
        },
        {
          title: "Study Tour",
          link: "https://studytour.niecindonesia.com/",
        },
      ]
    },

    contact: {
      caption: "Contacts",
      body: [
        {
          name: "+62 811-3891-4770 (WA)",
          icon: <FaPhone />,
          url: "https://wa.me/6281138914770"
        },
        {
          name: "info@niecindonesia.com",
          icon: <FaEnvelope />,
          url: "mailto:info@niecindonesia.com"
        },
        {
          name: "Facebook",
          icon: <FaFacebookF />,
          url: "https://www.facebook.com/profile.php?id=61553630410640"
        },
        {
          name: "Linkedin",
          icon: <FaLinkedinIn />,
          url: "https://www.linkedin.com/company/niec-indonesia/"
        },
        {
          name: "Instagram",
          icon: <FaInstagram />,
          url: "https://www.instagram.com/niec_indonesia/"
        },
        {
          name: "Youtube",
          icon: <FaYoutube />,
          url: "https://www.youtube.com/channel/UCA5qiOgJdfMvADpyU7Oz7fQ"
        },
      ]
    },

    office: {
      caption: "Office",
      body: [
        { city: "Denpasar Office", address: "Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar, Kota Denpasar, Bali 80111", map: "https://maps.app.goo.gl/gUN8RdMAPZrRVsK56" },
        { city: "Jakarta Branch Office", address: "Haery 1 Building (Kantor MULA) - Office & Commercial Space, Jl. Kemang Sel. Raya No.151, RT.4/RW.4 - Jakarta", map: "https://maps.app.goo.gl/t5GXgtZc3hFgyrWA9" },
        { city: "Tangerang Branch Office", address: "Sanctuary Bintaro Co Working Space, Ruko Emerald Boulevard Bintaro, Tangerang Selatan, Banten 15227", map: "https://maps.app.goo.gl/G7cFaA3dYKbiAfcx6" },
        { city: "Bandung Branch Office", address: "Point Lab Co-working Space, Jl. Banda No.30 - Bandung", map: "https://maps.app.goo.gl/4XX7s7DvdtYHJrpg7" },
        { city: "Medan Branch Office", address: "GoWork Sinar Mas Land Plaza Jl. Pangeran Diponegoro No.18 Lt. 10 Medan Polonia - Kota Medan", map: "https://maps.app.goo.gl/rvPPF5Qdq9kBKLK78" },
        { city: "Yogyakarta Branch Office", address: "Jl. Bintaran Kidul No.36, Wirogunan, Kec. Mergangsan, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55151", map: "https://maps.app.goo.gl/RMLopKLx4djSciQSA" },
        { city: "Surabaya Branch Office", address: "IdeaHub Coworking Space Voza Tower, Jl. Mayjen HR. Muhammad No.31, Putat Gede, Surabaya-Jawa Timur", map: "https://maps.app.goo.gl/9cR1bZhCH9mMzYE56" },
        { city: "Makassar Branch Office", address: "Bikin Bikin Creative Hub Mall Nipah, Jl. Urip Sumoharjo No.23C Panakkukang - Kota Makassar", map: "https://maps.app.goo.gl/b4ZkZrm4sNuHQ63E8" },
        { city: "Kuta Branch Office", address: "Jl. Bypass Ngurah Rai No.67, Kedonganan, Kec. Kuta, Kabupaten Badung, Bali 80361", map: "https://maps.app.goo.gl/NQ4nGsaAPzHgHH9N9" },
      ]
    },
  }

  return (
    <section id="footer" className='footer-wrapper'>
      <footer className="container">
        {/* <div className='d-flex'>
            <h6 className='pe-2'>Follow us on</h6>
            <div className="social-links">
                <a href="https://id-id.facebook.com/niec.indonesia/" target='_blank' className="facebook"><i className="bx bxl-facebook"></i></a>
                <a href="https://www.instagram.com/niec_indonesia/" target='_blank' className="instagram"><i className="bx bxl-instagram"></i></a>
                <a href="https://www.tiktok.com/@niec_indonesia?lang=id-ID" target='_blank' className="instagram"><i className="bx bxl-tiktok"></i></a>
            </div>
          </div> */}
        <div className='row my-4'>
          <div className='col-lg-6'>
            <img src="/assets/img/logo/logo.webp" className="img-fluid logo-niec" />
            <p className='pt-2'>
              Dengan pengalaman {experienceYears} tahun, kami telah memberangkatkan ribuan
              anak Indonesia kuliah di luar negeri. Bekerja sama dengan
              lebih dari 250 kampus secara langsung ke destinasi puluhan negara
            </p>
          </div>
          <div className='col-lg-3'>
            <h5>
              {data.explore.caption}
            </h5>
            <ul className='ps-0'>
              {data.explore.body.map((item, id) => (
                <li key={id}>
                  <a href={item.link} target='_blank'>
                    <span className='d-flex gap-3'>{item.title}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className='col-lg-3'>
            <h5>{data.contact.caption}</h5>
            <ul className='ps-0'>
              {data.contact.body.slice(0, 2).map((item, id) => (
                <li key={id}>
                  <a href={item.url}>
                    <span className='d-flex gap-2'>{item.icon}{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
            <ul className='d-flex align-items-center ps-0 social-links'>
              Follow us on :
              {data.contact.body.slice(2, 6).map((item, id) => (
                <li key={id}>
                  <a href={item.url} target='_blank' rel='noopener noreferrer'>
                    <span className='d-flex'>{item.icon}</span>
                  </a>
                </li>
              ))}
            </ul>
            <div>
              <p className='mb-1'>Jelajahi Super Student</p>
              <div className="items-center">
                <a href="https://apps.apple.com/us/app/super-student/id1614354792" target="_blank" className='pe-2' >
                  <img src='/assets/img/slide/home/logo_app_store.png' className="img-fluid w-25" alt="app-download-apple-store" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=io.niec.superstudent&hl=en&gl=US" target="_blank">
                  <img src='/assets/img/slide/home/logo_app_google.png' className="img-fluid w-25" alt="app-download-play-store" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          {data.office.body.map((item, id) => (
            <div key={id} className='col-lg-3 d-flex'>
              <a href={item.map} target='_blank' rel='noopener noreferrer'>
                <h6>{item.city}</h6>
                <p>{item.address}</p>
              </a>
            </div>
          ))}
        </div>
        <div className='text-center mt-5'>
          © {thisYear} NIEC Indonesia. All Rights Reserved. CV Naresy Indonesia
        </div>
      </footer>
    </section>
  );
}

export default footers;